import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

export interface ValidVariant {
  vetic_variant_id: string;
  sku_name: string;
  brand_name: string;
}

export interface UploadVariantsResponse {
  valid_variants: ValidVariant[];
  invalid_variant_ids: string[];
}

AxiosCurlirize(axios, () => {});

type UploadVariantsAPIResponse = { status: boolean; data: UploadVariantsResponse | null };

export const useUploadVariantsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (file: File) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const formData = new FormData();
        formData.append("file", file);

        const response: UploadVariantsAPIResponse = await axios
          .post(COUPON_SERVICE_APIS?.UPLOAD_VARIANTS?.baseURL ?? "", formData, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res: AxiosResponse<any>) => {
            const raw = res.data;
            // Normalise: API may return payload flat or wrapped under a `data` key
            const payload: UploadVariantsResponse = raw?.valid_variants ? raw : raw?.data;
            console.log("Upload variants API response:", raw, "| resolved payload:", payload);
            if (payload?.valid_variants) {
              const { invalid_variant_ids } = payload;
              if (invalid_variant_ids?.length > 0) {
                toast.error(`${invalid_variant_ids.length} invalid variant ID(s) found and skipped.`);
              }
              return { status: true, data: payload };
            } else {
              return { status: false, data: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, data: null };
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, configuration, captureError, sendCurl],
  );

  return { execute };
};
